/* Styles for SandboxPanel.tsx */

.preview {
  font-size: 0.8125rem;
  line-height: 1.25rem;
  color: rgb(var(--fg-muted));
}

.preview-2 > :not([hidden]) ~ :not([hidden]) {
  margin-top: 0.5rem;
  margin-bottom: 0;
}

.preview-2 {
  font-size: 0.8125rem;
  line-height: 1.25rem;
  color: rgb(var(--fg-muted));
}

.preview__label {
  color: rgb(var(--fg));
}

.preview__code {
  font-family: "JetBrains Mono Variable", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 0.6875rem;
  line-height: 1rem;
}

.preview__text {
  font-size: 0.6875rem;
  line-height: 1rem;
  color: rgb(var(--fg-subtle));
}

.preview__label-2 {
  font-family: "JetBrains Mono Variable", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 12px;
  color: rgb(var(--fg));
}

.sandbox-panel > :not([hidden]) ~ :not([hidden]) {
  margin-top: 1.25rem;
  margin-bottom: 0;
}

.sandbox-panel--not-compact {
  max-width: 42rem;
}

.sandbox-panel__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.6875rem;
  line-height: 1rem;
  color: rgb(var(--fg-muted));
}

.sandbox-panel__num {
  font-family: "JetBrains Mono Variable", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  color: rgb(var(--fg));
}

.sandbox-panel__num-2 {
  color: rgb(var(--fg));
}

.sandbox-panel__form > :not([hidden]) ~ :not([hidden]) {
  margin-top: 1rem;
  margin-bottom: 0;
}

.sandbox-panel__block > :not([hidden]) ~ :not([hidden]) {
  margin-top: 0.75rem;
  margin-bottom: 0;
}

.sandbox-panel__button {
  font-size: 0.6875rem;
  line-height: 1rem;
  color: rgb(var(--accent));
}

.sandbox-panel__button:hover {
  text-decoration-line: underline;
}

.sandbox-panel__grid {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 0.75rem;
}

.sandbox-panel__icon {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0.5rem;
  display: none;
  width: 1rem;
  height: 1rem;
  color: rgb(var(--fg-subtle));
}

.sandbox-panel__input {
  font-family: "JetBrains Mono Variable", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.sandbox-panel__text {
  font-size: 0.6875rem;
  line-height: 1rem;
  color: rgb(var(--fg-subtle));
}

.sandbox-panel__box {
  border-radius: 0.5rem;
  border-width: 1px;
  border-color: rgb(var(--line));
  background-color: rgb(var(--canvas));
  padding-left: 0.875rem;
  padding-right: 0.875rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.sandbox-panel__block-2 {
  margin-bottom: 0.5rem;
}

.sandbox-panel__row-2 {
  margin-top: 0.75rem;
  display: flex;
  align-items: flex-start;
  gap: 0.375rem;
  border-top-width: 1px;
  border-color: rgb(var(--line));
  padding-top: 0.625rem;
  font-size: 0.6875rem;
  line-height: 1rem;
  color: rgb(var(--fg-subtle));
}

.sandbox-panel__icon-2 {
  margin-top: 1px;
  width: 0.75rem;
  height: 0.75rem;
  flex-shrink: 0;
}

.sandbox-panel__row-3 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

.sandbox-panel__label {
  font-size: 0.6875rem;
  line-height: 1rem;
  color: rgb(var(--fg-subtle));
}

.sandbox-panel__box-2 {
  border-radius: 0.5rem;
  border-width: 1px;
  padding-left: 0.875rem;
  padding-right: 0.875rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.sandbox-panel__box--applied {
  border-color: rgb(var(--line));
  background-color: rgb(var(--surface));
}

.sandbox-panel__box--not-applied {
  border-color: rgb(113 113 122 / 0.3);
  background-color: rgb(113 113 122 / 0.1);
}

.sandbox-panel__row-4 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  font-weight: 500;
  color: rgb(var(--fg));
}

.sandbox-panel__label-2 {
  font-family: "JetBrains Mono Variable", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 0.6875rem;
  line-height: 1rem;
  font-weight: 400;
  color: rgb(var(--fg-muted));
}

.sandbox-panel__text-2 {
  margin-top: 0.25rem;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  color: rgb(var(--fg-muted));
}

.sandbox-panel__block-3 {
  margin-top: 0.625rem;
}

.sandbox-panel__block-3 > :not([hidden]) ~ :not([hidden]) {
  margin-top: 0.25rem;
  margin-bottom: 0;
}

.sandbox-panel__list > :not([hidden]) ~ :not([hidden]) {
  margin-top: 0.25rem;
  margin-bottom: 0;
}

.sandbox-panel__link {
  font-family: "JetBrains Mono Variable", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 12px;
  color: rgb(var(--accent));
}

.sandbox-panel__link:hover {
  text-decoration-line: underline;
}

.sandbox-panel__text-3 {
  margin-top: 0.5rem;
  font-size: 0.6875rem;
  line-height: 1rem;
  color: rgb(var(--fg-subtle));
}

.sandbox-panel__section > :not([hidden]) ~ :not([hidden]) {
  margin-top: 0.5rem;
  margin-bottom: 0;
}

.sandbox-panel__list-2 > :not([hidden]) ~ :not([hidden]) {
  border-top-width: 1px;
  border-bottom-width: 0;
  border-color: rgb(var(--line));
}

.sandbox-panel__list-2 {
  border-radius: 0.5rem;
  border-width: 1px;
  border-color: rgb(var(--line));
}

.sandbox-panel-2 {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.8125rem;
  line-height: 1.25rem;
}

.sandbox-panel__label-3 {
  margin-top: 0.125rem;
  font-family: "JetBrains Mono Variable", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 0.6875rem;
  line-height: 1rem;
  color: rgb(var(--fg-subtle));
}

.sandbox-panel__block-4 {
  min-width: 0px;
  flex: 1 1 0%;
}

.sandbox-panel__block-5 {
  color: rgb(var(--fg));
}

.sandbox-panel__label-4 {
  margin-left: 0.375rem;
  font-family: "JetBrains Mono Variable", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 0.6875rem;
  line-height: 1rem;
  color: rgb(var(--fg-muted));
}

.sandbox-panel__block-6 {
  font-size: 0.6875rem;
  line-height: 1rem;
  color: rgb(var(--fg-subtle));
}

.sandbox-panel__section-2 > :not([hidden]) ~ :not([hidden]) {
  margin-top: 0.5rem;
  margin-bottom: 0;
}

.sandbox-panel__section-2 {
  border-radius: 16px;
  background-color: rgb(var(--surface));
  padding: 1rem 1.125rem;
  box-shadow: var(--shadow-card);
}

.sandbox-panel__row-5 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.sandbox-panel__block-7 {
  font-size: 0.8125rem;
  line-height: 1.25rem;
  font-weight: 500;
  color: rgb(var(--fg));
}

.sandbox-panel__text-4 {
  font-size: 0.6875rem;
  line-height: 1rem;
  color: rgb(var(--fg-muted));
}

.sandbox-panel__text-5 {
  display: flex;
  align-items: flex-start;
  gap: 0.375rem;
  font-size: 0.6875rem;
  line-height: 1rem;
  color: rgb(var(--fg-subtle));
}

@media (min-width: 640px) {
  .sandbox-panel__grid {
    grid-template-columns: 1fr auto 1fr 6rem;
    align-items: flex-end;
  }

  .sandbox-panel__icon {
    display: block;
  }
}

.sandbox-quick {
  display: grid;
  gap: 0.75rem;
}

.sandbox-quick__card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  border-radius: 16px;
  background-color: rgb(var(--surface));
  padding: 1rem 1.125rem 1.125rem;
  box-shadow: var(--shadow-card);
}

.sandbox-quick__title {
  font-size: 0.9375rem;
  font-weight: 650;
  letter-spacing: -0.01em;
  color: rgb(var(--fg));
}

.sandbox-quick__text {
  font-size: 0.875rem;
  line-height: 1.45;
  color: rgb(var(--fg-muted));
}

.sandbox-quick__mono {
  font-family: "JetBrains Mono Variable", ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.8125rem;
}

.sandbox-quick__result {
  border-radius: 12px;
  background-color: rgb(var(--fg) / 0.05);
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  color: rgb(var(--fg-muted));
}

.sandbox-panel__advanced-body {
  display: grid;
  gap: 1rem;
  padding-top: 0.75rem;
}

@media (min-width: 640px) {
  .sandbox-panel--not-compact .sandbox-quick {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sandbox-panel--not-compact .sandbox-quick__result {
    grid-column: 1 / -1;
  }
}
